export function apiDocumentUpload({jsonRequest, PDFFiles, documentList}) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve({
                data: 'OK',
            });
        }, 500);
    });
}
